export default {
  SUCCESS: 'SUCCESS',
  NULL_OR_EMPTY: 'NULL_OR_EMPTY',
  BAD_IMAGE: 'BAD_IMAGE',
  DUPLICATED_MESSAGE: 'DUPLICATED_MESSAGE',
  TOO_LONG_MESSAGE: 'TOO_LONG_MESSAGE',
  OPERATION_NOT_PERMITTED: 'OPERATION_NOT_PERMITTED',
  NO_AUTHORIZATION: 'NO_AUTHORIZATION',
  ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
  TEMPORARILY_LOCKED_ACCOUNT: 'TEMPORARILY_LOCKED_ACCOUNT',
  INVALID_OR_EXPIRED_TOKEN: 'INVALID_OR_EXPIRED_TOKEN',
  LIMIT_REACHED: 'LIMIT_REACHED',
  API_EXCEPTION: 'API_EXCEPTION',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
};
